<app-spinner></app-spinner>
<div>
  <div class="modal-header rb-modal-header">
    <h4 class="modal-title font-weight-bold text-black-1">{{ title_tag }}</h4>
  </div>
  <div class="modal-body">
    <form [formGroup]="surveyQuestionForm" novalidate>
      <div class="row mt-3">
        <div class="col-4">
          <label for="qtext" class="text-black-1">Question text</label>
        </div>
        <div class="input-group col-8">
          <quill-editor formControlName="qtext" [styles]="{ height: '200px' }" [modules]="quillConfig"></quill-editor>

          <!-- <textarea
            id="qtext"
            class="form-control rb-input"
            placeholder="Add question text."
            formControlName="qtext"
            name="qtext"
            type="text"
          >
          </textarea> -->
          <div class="col-12 error-mssg" *ngIf="(f.qtext.touched || submitted) && f.qtext.errors">
            <label for="qtext" class="text-danger" *ngIf="f.qtext.errors.required">*Question text is required.</label>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-4">
          <label for="qtype" class="text-black-1" translate>Question type</label>
        </div>
        <div class="input-group col-8">
          <p-dropdown
            class="w-100-p"
            [options]="qtypeFields"
            optionLabel="viewValue"
            (onChange)="selectQuestionType($event)"
            formControlName="qtype"
            placeholder="Select question type."
          ></p-dropdown>
          <div class="col-12 error-mssg" *ngIf="(f.qtype.touched || submitted) && f.qtype.errors">
            <label for="qtype" class="text-danger" *ngIf="f.qtype.errors.required">
              *Please select the question type.
            </label>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-4">
          <label for="sequence" class="text-black-1">Sequence (Position of question)</label>
        </div>
        <div class="input-group col-8">
          <input
            id="sequence"
            class="form-control rb-input"
            placeholder="Please enter position of question."
            formControlName="sequence"
            name="sequence"
            type="number"
          />
          <div class="col-12 error-mssg" *ngIf="(f.sequence.touched || submitted) && f.sequence.errors">
            <label for="sequence" class="text-danger" *ngIf="f.sequence.errors.required">*Sequence is required.</label>
          </div>
        </div>
      </div>

      <ng-container *ngIf="selectedQuestionType === 'Date-Range'">
        <div class="row mt-3">
          <div class="col-4">
            <label for="date-range-min" class="text-black-1">Date(min)</label>
          </div>
          <div class="input-group col-8">
            <p-calendar
              formControlName="min"
              class="wd-100"
              [yearRange]="dateYearRange"
              [yearNavigator]="true"
              dateFormat="yy-mm-dd"
              inputId="monthpicker"
              placeholder="To: please select date range."
              [disabled]="show_answers"
            >
            </p-calendar>
            <div class="col-12 error-mssg" *ngIf="(f.min.touched || submitted) && f.min.errors">
              <label for="min" class="text-danger" *ngIf="f.min.errors.numberRequired">
                *Please enter a minimum number.
              </label>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="date-range-max" class="text-black-1">Date(Max)</label>
          </div>
          <div class="input-group col-8">
            <p-calendar
              formControlName="max"
              [yearRange]="dateYearRange"
              [yearNavigator]="true"
              dateFormat="yy-mm-dd"
              class="wd-100"
              inputId="monthpicker"
              placeholder="From: please select date range."
              [disabled]="show_answers"
            >
            </p-calendar>
            <div class="col-12 error-mssg" *ngIf="(f.max.touched || submitted) && f.max.errors">
              <label for="max" class="text-danger" *ngIf="f.max.errors.numberRequired">
                *Please enter a maximum number.
              </label>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="selectedQuestionType === 'Time-Range'">
        <div class="row mt-3">
          <div class="col-4">
            <label for="time-range-min" class="text-black-1">Time(Min.)</label>
          </div>
          <div class="input-group col-8">
            <p-calendar
              formControlName="min"
              class="wd-100"
              hourFormat="12"
              [timeOnly]="true"
              inputId="timeonly"
              placeholder="please select min time."
              [disabled]="show_answers"
            >
            </p-calendar>
            <div class="col-12 error-mssg" *ngIf="(f.min.touched || submitted) && f.min.errors">
              <label for="min" class="text-danger" *ngIf="f.min.errors.numberRequired">
                *Please enter a minimum number.
              </label>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="time-range-max" class="text-black-1">Time(Max)</label>
          </div>
          <div class="input-group col-8">
            <p-calendar
              formControlName="max"
              class="wd-100"
              hourFormat="12"
              [timeOnly]="true"
              inputId="timeonly"
              placeholder="please select max time."
              [disabled]="show_answers"
            >
            </p-calendar>
            <div class="col-12 error-mssg" *ngIf="(f.max.touched || submitted) && f.max.errors">
              <label for="max" class="text-danger" *ngIf="f.max.errors.numberRequired">
                *Please enter a maximum number.
              </label>
            </div>
          </div>
        </div>
      </ng-container>
      <!--      <ng-container *ngIf="selectedQuestionType === 'Info'">-->
      <!--        <div class="row mt-3">-->
      <!--          <div class="col-4">-->
      <!--            <label class="text-black-1">Info Text</label>-->
      <!--          </div>-->
      <!--          <div class="input-group col-8">-->
      <!--            <input-->
      <!--              class="form-control rb-input"-->
      <!--              placeholder="Add some Info text"-->
      <!--              formControlName="info"-->
      <!--              name="text"-->
      <!--              type="text"-->
      <!--            />-->
      <!--            <div class="col-12 error-mssg" *ngIf="(f.info.touched || submitted) && f.info.errors">-->
      <!--              <label for="min" class="text-danger" *ngIf="f.info.errors.required">-->
      <!--                *Please enter Some info.-->
      <!--              </label>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </ng-container>-->

      <ng-container
        *ngIf="
          selectedQuestionType === 'Scale' ||
          selectedQuestionType === 'String' ||
          selectedQuestionType === 'Number' ||
          selectedQuestionType === 'Number-Range'
        "
      >
        <div class="row mt-3">
          <div class="col-4">
            <label for="num-range-min" class="text-black-1">Min</label>
          </div>
          <div class="input-group col-8">
            <input
              id="min"
              class="form-control rb-input"
              [placeholder]="
                selectedQuestionType === 'String' ? 'Please enter min length of string.' : 'Please enter min number.'
              "
              formControlName="min"
              name="min"
              type="number"
            />
            <div class="col-12 error-mssg" *ngIf="(f.min.touched || submitted) && f.min.errors">
              <label for="min" class="text-danger" *ngIf="f.min.errors.numberRequired">
                *Please enter a minimum number.
              </label>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-4">
            <label for="num-range-max" class="text-black-1">Max</label>
          </div>
          <div class="input-group col-8">
            <input
              id="max"
              class="form-control rb-input"
              [placeholder]="
                selectedQuestionType === 'String' ? 'Please enter max length of string.' : 'Please enter max number.'
              "
              formControlName="max"
              name="max"
              type="number"
            />
            <div class="col-12 error-mssg" *ngIf="(f.max.touched || submitted) && f.max.errors">
              <label for="max" class="text-danger" *ngIf="f.max.errors.numberRequired">
                *Please enter a maximum number.
              </label>
            </div>
          </div>
        </div>
        <div class="row mt-3" *ngIf="selectedQuestionType === 'Scale'">
          <div class="col-4">
            <label for="steps" class="text-black-1">Steps</label>
          </div>
          <div class="input-group col-8">
            <input
              id="step"
              class="form-control rb-input"
              placeholder="Please enter the steps difference between min and max."
              formControlName="step"
              name="step"
              type="number"
            />
            <div class="col-12 error-mssg" *ngIf="(f.step.touched || submitted) && f.step.errors">
              <label for="steps" class="text-danger" *ngIf="f.step.errors.numberRequired">
                *Please enter the steps range betweeb min and max.
              </label>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="selectedQuestionType === 'Options' || selectedQuestionType === 'Multiple-Option'">
        <div class="row mt-3">
          <div class="col-12">
            <label for="options" class="text-black-1">Options</label>
          </div>
          <div class="input-group" formArrayName="options">
            <div class="mt-2 wd-100" *ngFor="let opt of optionsData.controls; let idx = index">
              <div class="row" [formGroupName]="idx">
                <div class="col-5 d-flex-col">
                  <label for="options-val" class="text-black-1">Value</label>
                  <input
                    id="val"
                    class="form-control rb-input"
                    placeholder="Please enter value."
                    formControlName="val"
                    name="val"
                    type="number"
                  />
                  <div class="col-12 error-mssg" *ngIf="(opt.get('val').touched || submitted) && opt.get('val').errors">
                    <label for="options-val" class="text-danger" *ngIf="opt.get('val').errors.required"
                      >*Option value is required.</label
                    >
                  </div>
                </div>
                <div class="col-5 d-flex-col">
                  <label for="options-text" class="text-black-1">Text</label>
                  <input
                    id="text"
                    class="form-control rb-input"
                    placeholder="Please enter text."
                    formControlName="text"
                    name="text"
                    type="text"
                  />
                  <div
                    class="col-12 error-mssg"
                    *ngIf="(opt.get('text').touched || submitted) && opt.get('text').errors"
                  >
                    <label for="options-text" class="text-danger" *ngIf="opt.get('text').errors.required"
                      >*Option text is required.</label
                    >
                  </div>
                </div>
                <div *ngIf="!show_answers" class="col-2 delete-box">
                  <img (click)="removeOption(idx)" src="../../../../assets/images/core/delete.png" />
                </div>
              </div>
            </div>
            <button *ngIf="!show_answers" class="btn-save mt-3 w-100" (click)="addNewOption()">Add Option</button>
          </div>
        </div>
      </ng-container>

      <div class="row mt-3">
        <div class="col-12">
          <label for="conditions" class="text-black-1">Conditions</label>
        </div>
        <div class="input-group" formArrayName="dependencies">
          <div class="wd-100" *ngFor="let opt of dependenciesData.controls; let idx = index">
            <div class="row" [formGroupName]="idx">
              <div class="col-12 d-flex-col">
                <div class="d-flex-row">
                  <label for="condition-question" class="text-black-1 question_label">Question {{ idx }}</label>
                  <i (click)="removeDependency(idx)" class="fa fa-times question_close" aria-hidden="true"></i>
                </div>
                <p-dropdown
                  class="w-100-p"
                  [options]="data_table"
                  optionLabel="qtext"
                  (onChange)="selectQuestionType($event)"
                  formControlName="qUUID"
                  placeholder="Select question type."
                  [disabled]="show_answers"
                >
                  <ng-template let-country pTemplate="item">
                    <div class="country-item">
                      <div [innerHTML]="country.qtext"></div>
                    </div>
                  </ng-template>
                </p-dropdown>
                <div
                  class="col-12 error-mssg"
                  *ngIf="(opt.get('qUUID').touched || submitted) && opt.get('qUUID').errors"
                >
                  <label for="qUUID" class="text-danger" *ngIf="opt.get('qUUID').errors.required"
                    >*Please select the condtion.</label
                  >
                </div>
              </div>
              <div class="col-12 d-flex-col mt-3">
                <div class="input-group" formArrayName="answer1">
                  <div class="wd-100" *ngFor="let ans of answersData(opt); let j = index">
                    <div class="row d-flex-row" [formGroupName]="j">
                      <div class="d-flex-col col-11 mt-1">
                        <label for="condition-answer" class="text-black-1 question_label">Answer {{ j }}</label>
                        <input
                          id="text"
                          class="form-control rb-input"
                          placeholder="Please enter text."
                          formControlName="ans"
                          name="ans"
                          type="text"
                        />
                        <div
                          class="col-12 error-mssg"
                          *ngIf="(ans.get('ans').touched || submitted) && ans.get('ans').errors"
                        >
                          <label for="condition-answer-text" class="text-danger" *ngIf="ans.get('ans').errors.required"
                            >*Answer for a condition is required.</label
                          >
                        </div>
                      </div>
                      <div class="col-1 delete-box">
                        <img
                          *ngIf="j > 0 && !show_answers"
                          (click)="removeAnswer(idx, j)"
                          src="../../../../assets/images/core/delete.png"
                        />
                      </div>
                    </div>
                  </div>
                  <button *ngIf="!show_answers" class="btn-save mt-3 w-100" (click)="addNewAnswer(idx)">
                    Add Answer
                  </button>
                </div>
              </div>
            </div>
          </div>
          <button
            class="btn-save mt-3 w-100"
            [disabled]="!(data_table.length > 0)"
            *ngIf="!show_answers"
            (click)="addNewDependency()"
            [ngClass]="!(data_table.length > 0) ? 'disable-btn' : ''"
          >
            Add Condition
          </button>
        </div>
      </div>
    </form>
    <div class="mt-3 d-flex-col" *ngIf="show_answers">
      <span> Answer: </span>
      <div *ngFor="let surveyAnswer of form_data['answer'] | keyvalue">
        <ng-container *ngIf="surveyAnswer.key !== 'qUUID'">
          <span *ngIf="surveyAnswer.key !== 'answer1'">
            Key: <b>{{ surveyAnswer.key }}</b>
          </span>
          <span>
            Value: <b>{{ surveyAnswer.value }}</b>
          </span>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="modal-footer border-0 rb-modal-footer">
    <button class="btn-cancel ml-4 w-100" (click)="activeModal.close(false)" ngbAutoFocus>Cancel</button>
    <button class="btn-save ml-4 w-100" *ngIf="!isLoading && !show_answers" (click)="save()">Submit</button>
    <button class="btn-save ml-4 w-100" disabled *ngIf="isLoading">
      <i class="fa fa-spinner fa-spin" style="font-size: 16px"></i>
    </button>
  </div>
</div>
